export interface OrderPartsSubModel {
  productNumber?: string;
  serialNumber?: string;
  entity?: string;
}

export interface OrderPartsModel {
  id?: string;
  reorderFullBundle?: boolean;
  parts: OrderPartsSubModel[];
}

export function orderPartsSubModelFactory(json?: any): OrderPartsSubModel {
  json = json || {};
  return {
    productNumber: json.productNumber || "",
    serialNumber: json.serialNumber || "",
    entity: json.entity || "",
  } as OrderPartsSubModel;
}

export function orderPartsSubModelListFactory(json?: any): OrderPartsSubModel[] {
  return Array.from(json || []).map(it => orderPartsSubModelFactory(it)) as OrderPartsSubModel[];
}

export function orderPartsModelFactory(json?: any): OrderPartsModel {
  json = json || {};

  return {
    id: json.id || "",
    reorderFullBundle: !!json.reorderFullBundle,
    parts: orderPartsSubModelListFactory(json.parts),
  } as OrderPartsModel;
}

export function orderPartsModelListFactory(json?: any): OrderPartsModel[] {
  return Array.from(json || []).map(it => orderPartsModelFactory(it)) as OrderPartsModel[];
}
